import erreurSrc from '~/src/assets/illustrations/erreur.png';
import Button from '~/src/common/components/Button';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

interface Props {
  text?: string;
  button?: string;
  onClick: () => unknown;
}

const ErrorLarge = ({
  text = I18n.t('common.error-label'),
  button = I18n.t('common.error-button'),
  onClick,
}: Props) => (
  <S.ErrorLargeContainer>
    <img src={erreurSrc} />
    <p>{text}</p>
    <Button onClick={() => void onClick()}>{button}</Button>
  </S.ErrorLargeContainer>
);

export default ErrorLarge;
